"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = e => {
    const article = e.data;
    if (!article)
        return;
    if (typeof window.adobeDataLayer === 'undefined')
        return;
    window.adobeDataLayer.push({
        component: {
            relatedArticle: null,
        },
    });
    const analyticsEvent = {};
    analyticsEvent.event = 'cmp:click';
    analyticsEvent.eventInfo = {
        path: 'component.relatedArticle',
    };
    analyticsEvent.component = {
        relatedArticle: {
            'parent-component-variation': 'component-relatedArticles',
            'dc:title': article.title || 'NA',
            'xdm:linkURL': article.url || 'NA',
        },
    };
    window.adobeDataLayer.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
